import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CURRICULUM, REGISTRATION_URL } from "./data";

export const Curriculum = () => (
    <section id="materi" className="scroll-mt-20 bg-[#F8F6F1] py-20 lg:py-28" data-testid="curriculum-section">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
            <Reveal className="text-center">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">Kurikulum</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="curriculum-heading">
                    Apa Saja yang Akan{" "}
                    <span className="font-accent italic text-[#123E65]">Kamu Pelajari?</span>
                </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-12">
                <Accordion type="single" collapsible className="space-y-4" data-testid="curriculum-accordion">
                    {CURRICULUM.map((c, i) => (
                        <AccordionItem key={c.title} value={`materi-${i + 1}`}
                            className="overflow-hidden rounded-2xl border border-[#071B37]/8 bg-white px-6 shadow-[0_4px_20px_rgba(7,27,55,0.05)] transition-colors duration-300 data-[state=open]:border-[#DDB56C]/50"
                            data-testid={`curriculum-item-${i + 1}`}>
                            <AccordionTrigger className="py-5 text-left hover:no-underline" data-testid={`curriculum-trigger-${i + 1}`}>
                                <span className="flex items-start gap-4">
                                    <span className="font-accent text-xl font-semibold text-[#DDB56C]">{String(i + 1).padStart(2, "0")}</span>
                                    <span className="text-base font-bold text-[#1C2533] sm:text-lg">{c.title}</span>
                                </span>
                            </AccordionTrigger>
                            <AccordionContent className="pb-6 pl-11 text-sm leading-relaxed text-[#1C2533]/70 sm:text-base" data-testid={`curriculum-content-${i + 1}`}>
                                {c.desc}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
            <Reveal delay={0.15} className="mt-10 text-center">
                <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="curriculum-cta"
                    className="group inline-flex items-center gap-2 rounded-full bg-[#071B37] px-8 py-4 text-base font-bold text-white transition-all duration-300 hover:-translate-y-1 hover:bg-[#123E65] hover:shadow-[0_12px_32px_rgba(7,27,55,0.35)]">
                    Belajar Strategi KPR Sekarang
                    <ArrowRight className="h-5 w-5 text-[#DDB56C] transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
                </a>
            </Reveal>
        </div>
    </section>
);
